export const isValidUrl = (url: string) => {
    try {
        return !!new URL(url);
    } catch {
        return false;
    }
};

export const joinUrl = (baseUrl: string | URL, path: RequestInfo | URL) => {
    const base = baseUrl.toString().endsWith('/') ? baseUrl.toString() : `${baseUrl.toString()}/`;

    const pathString = typeof path === 'string' ? path : path.toString();

    const pathWithoutLeadingSlash = pathString.startsWith('/') ? pathString.substring(1) : pathString;

    try {
        return new URL(pathWithoutLeadingSlash, base).href;
    } catch {
        return pathString;
    }
};

export const joinUrlOrPath = (baseUrlOrPath: string | URL, path?: RequestInfo | URL) => {
    let fullPathOrUrl: string;

    // Check if baseUrlOrPath is a full URL
    const isFullUrl =
        baseUrlOrPath instanceof URL ||
        (typeof baseUrlOrPath === 'string' &&
            isValidUrl(baseUrlOrPath) &&
            (baseUrlOrPath.startsWith('http://') || baseUrlOrPath.startsWith('https://')));

    if (isFullUrl) {
        fullPathOrUrl = joinUrl(baseUrlOrPath, path || '');
    } else {
        const normalizedBaseUrlOrPath = baseUrlOrPath.endsWith('/') ? baseUrlOrPath.slice(0, -1) : baseUrlOrPath;

        const normalizedPath = path
            ? path.toString().startsWith('/')
                ? path.toString().substring(1)
                : path.toString()
            : '';

        fullPathOrUrl = `${normalizedBaseUrlOrPath}/${normalizedPath}`;
    }

    // Ensure the path starts with '/' only if it's not a full URL
    if (!isFullUrl && !fullPathOrUrl.startsWith('/')) {
        fullPathOrUrl = `/${fullPathOrUrl}`;
    }

    return fullPathOrUrl;
};
